<template>
  <div>
    <el-card>
      <!-- 搜索 添加 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="设备IMEI">
          <el-input v-model.trim="queryParams.deviceImei" placeholder="请输入设备IMEI"></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="selectTimeFunc"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="warning" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="alarmList" border stripe>
        <el-table-column prop="alarmId" label="alarmId" v-if="false"></el-table-column>
        <el-table-column prop="alarmTime" label="警报时间"></el-table-column>
        <el-table-column prop="alarmType" label="警报类型" :formatter="alarmTypeFormatter"></el-table-column>
        <el-table-column prop="deviceImei" label="设备IMEI" ></el-table-column>
        <el-table-column prop="readFlag" label="已读标识" :formatter="readFlagFormatter"></el-table-column>
        <el-table-column prop="longitude" label="经度" ></el-table-column>
        <el-table-column prop="latitude" label="纬度" ></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

  </div>
</template>

<script>
import { checkLogin } from '@/api/globalProcessErr'
import {listSysLog} from "@/api/sysLog";
import {listUser} from "@/api/sysUser";
import {listCodeByClass} from "@/api/code";
import {parseTime} from "@/api/util";
import {listAlarm} from "@/api/deviceAlarm";

export default {
  data () {
    return {
      queryParams: {
        deviceImei: '',
        startTime: '',
        endTime: '',
        // 当前页数
        pageNum: 1,
        // 每页显示多少数据
        pageSize: 20
      },
      timeRange: [
        new Date((new Date()) - 30 * 24 * 60 * 60 * 1000),
        new Date()
      ],
      alarmTypeDicList: [],
      alarmList: [],
      userList: [],
      total: 0,
      minTime: undefined,
      maxTime: undefined,
    }
  },
  computed: {

  },
  created () {
    this.$i18n.locale = window.sessionStorage.getItem('lang')
  },
  mounted() {
    let self = this
    this.getAlarmTypeCode().then(()=>{
      self.getAlarmList()
    })
  },
  methods: {
    getAlarmList () {
      this.selectTimeFunc()
      const req = this.queryParams
      listAlarm(req).then(res => {
        checkLogin(res)
        const code = res.data.code
        if (code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.alarmList = res.data.data.list
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    async getAlarmTypeCode(){
      let self = this
      await listCodeByClass('ALARM_TYPE').then(res =>{
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.alarmTypeDicList = res.data.data
      })
    },
    // 监听 pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryParams.pageSize = newSize
      this.getAlarmList()
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryParams.pageNum = newSize
      this.getAlarmList()
    },
    alarmTypeFormatter(row,column){
      let alarmType = String(row.alarmType)
      for(let i=0;i<this.alarmTypeDicList.length;i++){
        if (alarmType === this.alarmTypeDicList[i].codeValue){
          return this.alarmTypeDicList[i].codeName
        }
      }
    },
    readFlagFormatter (row, column) {
      if (row.readFlag === 1) {
        return '已读'
      } else {
        return '未读'
      }
    },
    selectTimeFunc(){
      if (this.timeRange === undefined || this.timeRange === null
        || this.timeRange[0] === undefined || this.timeRange[0] === null
        || this.timeRange[1] === undefined || this.timeRange[1] === null){
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        return
      }
      this.queryParams.startTime = parseTime(this.timeRange[0], '{y}-{m}-{d} 00:00:00')
      this.queryParams.endTime = parseTime(this.timeRange[1], '{y}-{m}-{d} 23:59:59')
    },
    search() {
      this.getAlarmList()
    },
    resetSearch () {
      this.queryParams = {
        deviceImei: '',
        startTime: '',
        endTime: '',
      }
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 20
      this.getAlarmList()
    },
  }
}
</script>

<style lang="less" scoped>
.myButton {

}
</style>
